<template>
  <div :class="{'hashead hasservice':!isPC}">
    <LeaveTel ref="LeaveTel" :isSingle="true" :estate="[estateItem.phone,estateItem.estateId,estateItem.estateName]" :isXprtFlag="isXprtFlag" :isFind="isFind"  @setIsFind="getIsFind" @clickButton="leaveClick" @setError="getError" :isCode="showCode" @setIsCode="getIsCode" :isShowXy="isShowXy" @setIsShowXy="getIsShowXy"></LeaveTel>
    <WapHeader v-if="!isPC" :showlogo="true"></WapHeader>
    <div class="banner">
      <img v-if="recomItem.bannerPath" :src="recomItem.bannerPath" @click="$router.push({path:'/estateDetail?estateId='+estateItem.estateId})">
      <i v-if="showTv==1&&estateItem.tvUrl&&estateItem.tvUrl!=''" class="i-video" @click="currVideoPath=estateItem.tvUrl"></i>

      <div class="estatedesc">
        <div class="descbox">
          <h1 v-if="recomItem.hotName&&recomItem.hotName.length<7">{{recomItem.hotName}}</h1>
          <h1 v-if="recomItem.hotName&&recomItem.hotName.length>6&&recomItem.hotName.length<8" style="font-size:40px;line-height:45px;">{{recomItem.hotName}}</h1>
          <h1 v-if="recomItem.hotName&&recomItem.hotName.length>7" style="font-size:32px;line-height:40px;height:40px;">{{recomItem.hotName}}</h1>
          <h2 v-if="recomItem.hotDesc">{{recomItem.hotDesc}}</h2>
          <h3 v-if="estateItem.randomNumber">目前已有<em>{{estateItem.randomNumber}}</em>人预约</h3>
          <p class="address" v-if="estateItem.positionDetail">地址：{{'['+estateItem.locationSt+'-'+estateItem.locationSC+'] '+estateItem.positionDetail}}</p>
        </div>
      </div>
      <VideoPlay :videoPath="currVideoPath" @clearPath="currVideoPath=''"></VideoPlay>
    </div>
    <div class="inputwrap">
      <h4>获取最新报价及优惠折扣</h4>
      <div class="inputbox"><input type="text" placeholder="请输入姓名" v-model="ljdyfydtName" ref="name"></div>
      <div class="inputbox"><input type="tel" placeholder="请输入手机号" v-model="ljdyfydtPhone" ref="phone"></div>
      <!-- <label  v-show="codeInputShow==1">验证码</label>
      <div class="inputbox" v-show="codeInputShow==1"><input type="number" placeholder="请输入验证码" v-model="ljdyfydtCode" ref="code">
        <span class="code" v-show="codeShow" @click="getCode(ljdyfydtPhone)" >验证码</span>
        <span class="code wait" v-show="!codeShow">重新获取{{count}}s</span>
      </div> -->
      <p class="error" v-show="errorMsg!=null" >{{errorMsg}}</p>
      <p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
      <a @click="isShowXy=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
			<a @click="isShowXy=true;" v-if="$store.state.domainIndex==2">《素旭用户协议》</a>
      (点击可取消)</p>
      <p class="mbutton" @click="leaveClick(0)" >立即获取</p>
      <div class="userwrap" v-if="recomItem&&(recomItem.ucSw==1||recomItem.usSw==1)">
        <div class="usercount" v-if="recomItem.ucSw==1&&recomItem.userCount!=null"><i class="tzicon"></i><p v-html = recomItem.userCount></p></div>
        <div class="userbox" :class="{'userboxbar':recomItem.userShowType==2}" v-if="recomItem.usSw==1&&recomItem.userShowPlace==1">
          <p class="utitle" v-if="recomItem.userShowType==1"><b>最新报名客户</b></p>
          <i class="m-icon i-huo" v-if="recomItem.userShowType==2"></i>
          <div class="userlist">
            <div class="listbox">
              <div>
                <li :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li></div>
              <div>
                <li v-if="index<5" :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer v-if="kfsData.developerName!=undefined" :kfsData="kfsData"></Footer>
  </div>
</template>

<script>
// import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import LeaveTel from '@/components/public/LeaveTel'
import Footer from '@/components/public/Footer'
import VideoPlay from '@/components/public/VideoPlay'
import recordHttp from '../store/recordPage.js'
export default {
  name: 'Recommend',
  components:{
    // 'Header':Header,
    'WapHeader':WapHeader,
    'LeaveTel':LeaveTel,
    'Footer':Footer,
    'VideoPlay':VideoPlay,
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
      recomItem:[],
      userItem:[],
      kfsData:{},
      codeShow:true,
      count: '',
      timer: null,
      count_e: '',
      timer_e: null,
      isFind:false,
      isXprtFlag:true,
      estateItem:[],
      ljdyfydtName:null,
      ljdyfydtPhone:null,
      ljdyfydtCode:null,
      errorMsg:null,
      codeInputShow: 2,
      currVideoPath:'',
      vcodeSt:2,
      showTv:2,
      showCode:false,
      isCheck:false,
      isShowXy:false
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted(){
    var _this = this;

    _this.getRecom();
  },
  methods:{

    changeCheck(){
      this.isCheck=!this.isCheck;
    },
    getIsShowXy(data){
      this.isShowXy = data;
    },
    getRecom:function(){
      this.$http.get('/api/baidu/getHotThemeEstateList?id='+this.$route.query.id).then((response)=>{
        this.recomItem = response.data.result;
        this.estateItem = response.data.result.estateList[0];
        this.userItem = response.data.result.usList;
        this.kfsData.developerName=this.estateItem.developerName;
        this.kfsData.permit=this.estateItem.permit;
        this.codeInputShow = response.data.result.codeInputShow;
        this.showTv = response.data.result.showTv;

        recordHttp.recordPage(this,this.recomItem.projectPkId,this.estateItem.estateId,this.estateItem.estateName,this.estateItem.phone);
      }).catch((response)=>{
        console.log(response)
      })
    },
    getIsFind:function(data){
      this.ljdyfydtName = '';
      this.ljdyfydtPhone = '';
      this.ljdyfydtCode = '';
      this.isFind = data;
      this.showCode=false;
    },
    getError(data){
      this.errorMsg = data;
      this.hideError();
    },
    getIsCode(data){
      this.showCode=data;
    },
    // getCode: function(mobile){

    //   //校验手机号码
    //   if(!this.$refs.LeaveTel.checkPhone(mobile)){
    //     this.errorMsg ='请输入正确的手机号码';
    //     return false;
    //   }
    //   this.errorMsg = null;
    //   const TIME_COUNT = 60;
    //     if (!this.timer) {
    //       this.count = TIME_COUNT;
    //       this.codeShow = false;
    //       this.timer = setInterval(() => {
    //         if (this.count > 0 && this.count <= TIME_COUNT) {
    //           this.count--;
    //           } else {
    //           this.codeShow = true;
    //           clearInterval(this.timer);
    //           this.timer = null;
    //           }
    //         }, 1000)
    //       }

    //   //获取验证码
    //   this.$http.get('/api/user/getSmscode?mobile='+mobile).then((response)=>{
    //     console.log(response);
    //     if(response.data.result && !response.data.result.resultCode && response.data.result.msg!=null){
    //       this.errorMsg =  response.data.result.msg;
    //     }else{
    //       this.errorMsg = null;
    //     }
    //   }).catch((response)=>{
    //     console.log(response)
    //   })
    // },
    leaveClick:function(index){
      if(this.ljdyfydtName==null || this.ljdyfydtName==''){
        this.errorMsg ='请输入您的姓名';
        this.$refs.name.focus();
        this.hideError();
        return false;
      }
      //校验手机号码
      if(!this.$refs.LeaveTel.checkPhone(this.ljdyfydtPhone)){
        this.errorMsg ='请输入正确的手机号码';
        this.$refs.phone.focus();
        this.hideError();
        return false;
      }
      if(this.isCheck!=true){
        this.errorMsg ='请阅读并勾选用户协议';
        this.hideError();
        return false;
      }
      // this.errorMsg =null;
      if(this.codeInputShow==1){
        this.$refs.LeaveTel.getCode(this.ljdyfydtPhone);
        this.$refs.LeaveTel.setParams(24,this.estateItem.estateId,this.estateItem.estateName,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone,this.ljdyfydtName);
      //   if(this.ljdyfydtCode==null || this.ljdyfydtCode==''){
      //     this.errorMsg ='请输入验证码';
      //     this.$refs.code.focus();
      //     this.hideError();
      //     return false;
      //   }

      // //校验验证码
      //   this.$http.get('/api/user/checkSmsCode?mobile='+this.ljdyfydtPhone+'&smsCode='+this.ljdyfydtCode).then((response)=>{
      //     if(!response.data.result){
      //       this.errorMsg = '验证码错误';
      //       this.$refs.code.focus();
      //       this.hideError();
      //       return false;
      //     }
      //     this.submit();

      //   }).catch((response)=>{
      //     console.log(response)
      //     this.errorMsg = '验证码校验出错';
      //     return false;
      //   })
      }else{
        this.submit();
      }
    },
    hideError(){
      const TIME_COUNT1 = 2;
      if (!this.timer_e) {
        this.count_e = TIME_COUNT1;
        this.timer_e = setInterval(() => {
          if (this.count_e > 0 && this.count_e <= TIME_COUNT1) {
            this.count_e--;
          } else {
            this.errorMsg = null;
            clearInterval(this.timer_e);
            this.timer_e = null;
          }
        }, 1000)
      }
    },
    submit(){
      this.$refs.LeaveTel.setParams(24,this.estateItem.estateId,this.estateItem.estateName,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone,this.ljdyfydtName);
      this.$refs.LeaveTel.sendFromInLine();
      this.isFind =true;
      this.errorMsg = null;
      // this.ljdyfydtPhone='';
      // this.ljdyfydtName='';
    }
  }
}
</script>

<style scoped>
  .banner .logo{width:80px;height:auto;position:absolute;left:50%;top:0px;margin-left:-40px;z-index:1;padding:8px 0 7px;border-radius:5px;border-top-right-radius:0;border-top-left-radius:0;}
  .banner{position:relative;min-height:300px;background:#eee;}
  .banner img{width:100%;height:100%;object-fit:cover;display:block;}
  .estatedesc{position:absolute;left:0;right:0;bottom:0;background:linear-gradient(0deg,#0152ff 0,rgba(1,82,255,0.9) 50%,rgba(0,0,0,0) 100%);height:300px}
  .inputwrap{color:#2e303a;padding:20px 25px 25px;background:#fff;}
  .inputwrap h4{text-align:center;font-size:16px;letter-spacing:2px;line-height:20px;margin-bottom:15px;}
  .inputwrap label{display:block;line-height:20px;}
  .inputwrap .mbutton{margin-top:15px;border-radius:3px;line-height:40px;height:40px;}
  .bttitle{font-size:18px;font-weight:700;line-height:20px;}
  .error{position:fixed;z-index:9;color:#fff;background:rgba(0,0,0,0.6);bottom:90px;text-align:center;line-height:32px;border-radius:3px;width:240px;left:50%;margin-left:-120px;font-size:12px;}
  .tip{font-size:12px;line-height:18px;margin-top:8px;}
  .inputbox{height:20px;padding:8px 10px;border:1px solid #e1e1e1;border-radius:3px;line-height:20px;position:relative;margin:8px 0 20px;overflow:hidden;}
  .inputbox input{display:block;width:100%;font-size:15px;line-height:20px;}
  .inputbox span{position:absolute;width:35%;right:0;top:0;line-height:38px;color:#dc9806;text-decoration:underline;font-size:13px;text-align:center;}
  .inputbox span:before{content:'';position:absolute;left:0;top:8px;bottom:8px;border-left:1px solid #d2d2d2;}
  .inputbox span.wait{text-decoration:none;color:#aaa;}
  .descbox{position:absolute;left:30px;right:30px;bottom:10px;color:#fff;text-align:center;}
  .descbox h1{font-size:45px;font-family:serif;line-height:50px;margin-bottom:20px;overflow:hidden;}
  .descbox h2{font-weight:400;font-size:24px;line-height:40px;border:1px solid rgba(255,255,255,0.5);height:40px;overflow:hidden;}
  .descbox h3{font-weight:400;font-size:14px;line-height:32px;border:1px solid rgba(255,255,255,0.5);margin-bottom:30px;letter-spacing:1px;border-top:0;opacity:0.9}
  .descbox h3 em{font-size:15px;font-style:normal;color:#ffd03d;}
  .descbox .address{font-size:12px;width:111%;margin-left:-5.5%;transform:scale(0.9);opacity:0.9}
  .i-video{position:absolute;left:50%;top:50%;margin-left:-28px;margin-top:-128px;width:56px;height:56px;border-radius:50%;background:#fff url(../assets/images/i-video.png) 21px center no-repeat;background-size:19px;box-shadow:2px 2px 20px rgba(0,0,0,.5);z-index:1;}
</style>



// WEBPACK FOOTER //
// src/components/RecommendSingle.vue